import React, { useState }  from "react";
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button, CardText } from "reactstrap";
import { EmailLayout } from '../../../../../models';

const EmailWidgetsBrowser = ({ addWidget }) => {
    const { t } = useTranslation();

    const [type, setType] = useState(EmailLayout.TEXT);

    return (
        <div className="wrapper-1 mr-1">
            <div className="">
                <CardText tag="div" className="mb-4">
                    <ButtonGroup>
                        <Button color={type === EmailLayout.TEXT ? 'primary' : 'dark'} onClick={() => setType(EmailLayout.TEXT)}>
                            <i className="fa fa-comment-o" />{' '}
                            { t('layouts.text_widgets') }
                        </Button>
                        <Button color={type === EmailLayout.IMAGE ? 'primary' : 'dark'} onClick={() => setType(EmailLayout.IMAGE)}>
                            <i className="fa fa-picture-o" />{' '}
                            { t('layouts.image_widgets') }
                        </Button>
                    </ButtonGroup>
                </CardText>
                { type === EmailLayout.TEXT && (
                <CardText tag="div">
                    { EmailLayout.getAvailableWidgets(EmailLayout.TEXT).map((widget, index) => (
                        <Button key={ index } className="widgetBtn" color="outline" onClick={() => addWidget(widget.getType(), widget.getSubType())}>
                            <i className={ `fa fa-${widget.getIcon()}` } />{' '}
                            {t(`layouts.${widget.getType()}_${widget.getSubType()}`)}
                        </Button>
                    ))}
                </CardText>
                )}
                { type === EmailLayout.IMAGE && (
                <CardText tag="div">
                    { EmailLayout.getAvailableWidgets(EmailLayout.IMAGE).map(widget => (
                        <Button className="widgetBtn" color="outline" onClick={() => addWidget(widget.getType(), widget.getSubType())}>
                            <i className={ `fa fa-${widget.getIcon()}` } />{' '}
                            {t(`layouts.${widget.getType()}_${widget.getSubType()}`)}
                        </Button>
                    ))}
                </CardText>
                )}
            </div>
        </div>
    );
}

export default EmailWidgetsBrowser;
